import { render, staticRenderFns } from "./LightboxBranchingVideoCard.vue?vue&type=template&id=5009e956"
import script from "./LightboxBranchingVideoCard.vue?vue&type=script&lang=js"
export * from "./LightboxBranchingVideoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports